var youbora = require('youboralib')
require('youbora-adapter-hlsjs')
require('./adapter')

module.exports = youbora
